// extracted by mini-css-extract-plugin
module.exports = {"country-box":"country-box_nHSq","icon":"icon_2T1G","arr":"arr_18Jz","clist":"clist_1dTK","item":"item_3dSi","img":"img_1Suw"};